import { render } from "./FrisbuySrBranding.vue?vue&type=template&id=92e2786e&scoped=true"
import script from "./FrisbuySrBranding.vue?vue&type=script&lang=js"
export * from "./FrisbuySrBranding.vue?vue&type=script&lang=js"

import "./FrisbuySrBranding.vue?vue&type=style&index=0&id=92e2786e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92e2786e"]])

export default __exports__